jQuery(document).ready(function($) {

  var $stickyButton = $('#sticky-cta');
  var $window = $(window);
  var $body = $('body');
  var $hero = $('.hero');

  var heroHeight;


  function getHeroHeight() {
    if ($body.hasClass('home') || $body.hasClass('page-template-page-city')) {
      heroHeight = $hero.height();
    } else {
      heroHeight = 0;
    }
  }




  function showStickyCta() {
    if (window.innerWidth <= 767 && !$stickyButton.hasClass('show') && $window.scrollTop() >= heroHeight) {
      $stickyButton.addClass('show');
    } else if (
      (window.innerWidth > 767 && $stickyButton.hasClass('show')) ||
      ($stickyButton.hasClass('show') && $window.scrollTop() < heroHeight)) {
        $stickyButton.removeClass('show');
    }
  }

  $window.on('resize', getHeroHeight);
  $window.on('scroll resize', showStickyCta);
  getHeroHeight();
  showStickyCta();

})
